import { render, staticRenderFns } from "./collisionDetection.vue?vue&type=template&id=1d5d601a&scoped=true&lang=pug"
import script from "./collisionDetection.vue?vue&type=script&lang=js"
export * from "./collisionDetection.vue?vue&type=script&lang=js"
import style0 from "@/CommonDP/mongeView/common/common.scss?vue&type=style&index=0&id=1d5d601a&prod&lang=scss&scoped=true&external"
import style1 from "./collisionDetection.vue?vue&type=style&index=1&id=1d5d601a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5d601a",
  null
  
)

export default component.exports